import { notifyAdapter } from '@/features/messages/adapters/notify-adapter'
import { pbDepartments, pbMembers, pbOrgTeams } from './adapters/pb-members'
import { pbTimeoff } from './adapters/pb-timeoff'
import { pbHistory } from '@/features/shared/adapters/pb-history'
import { makeSyncedDepartments, makeSyncedOrgTeams } from './adapters/synced-hr'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { DepartmentPort, MemberPort, OrgTeamPort } from './domain/member'
import type { TimeOffPort } from './domain/timeoff'
import type { HistoryPort } from '@/features/shared/domain/history'

const members: MemberPort = pbMembers
const departments: DepartmentPort = pbDepartments
const orgTeams: OrgTeamPort = pbOrgTeams
const timeoff: TimeOffPort = pbTimeoff
const notify: NotifyPort = notifyAdapter
const history: HistoryPort = pbHistory

// Synced observables - auto-fetch on first access, port interface is the only dependency
const departments$ = makeSyncedDepartments(pbDepartments, notifyAdapter)
const orgTeams$ = makeSyncedOrgTeams(pbOrgTeams, notifyAdapter)

export { members, departments, orgTeams, timeoff, notify, history, departments$, orgTeams$ }
